import React, { useState } from "react";
import Collapsible from "react-collapsible";
import Tabs from "components/tabs";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const ProductAccordion = ({ accordion, titleClass }) => {
	const [active, setActive] = useState(false);
	return (
		<Collapsible
			transitionTime="200"
			triggerTagName="div"
			triggerElementProps={{ id: accordion._key }}
			contentElementId={accordion._key}
			onOpening={() => setActive(true)}
			onClosing={() => setActive(false)}
			trigger={[
				<span className={clsx("py-4 font-medium text-base", titleClass)} key={accordion.title}>
					{accordion.title}
				</span>,
				<div key={accordion._key} className={clsx("plus-minus-toggle", active && "before:rotate-90 after:rotate-180")}></div>,
			]}
			className="mobile-menu-border-top"
			openedClassName="mobile-menu-border-top"
		>

			<div>
				{accordion.type === "richText" &&
					<div className="product-accordion">
						<RichText value={accordion.content} />
					</div>}

				{accordion.type === "tabs" &&
					<div className="product-tabs">
						<Tabs
							className="mb-3.5"
							tabs={accordion?.tabsContent?.data.map(t =>
								({ label: t.title, content: <RichText value={t?.content} /> }))} />
					</div>}
			</div>
		</Collapsible>
	);
};

const RenderAccordions = ({ accordions, titleClass }) => accordions?.map((accordion) =>
	<ProductAccordion key={accordion?._key} accordion={accordion} titleClass={titleClass} />);

export default RenderAccordions;
